import { Observable } from 'rxjs';

/** execute condition within the observable stream */
export const ifThen =
  <T>(
    condition: () => boolean,
    then: (observable: Observable<T>) => Observable<T>,
    elseThen: (observable: Observable<T>) => Observable<T> = (o: Observable<T>) => o,
  ) =>
  (observable: Observable<T>) => {
    return condition() ? then(observable) : elseThen(observable);
  };
